import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private service: MatSnackBar) { }

  open(message: string, closeLabel: string = 'X') {
    return this.service.open(message, closeLabel,  {
      duration: 3000,
      panelClass: 'cim-toastr',
      verticalPosition: 'top'
    });
  }
  openWithAction(message: string, closeLabel: string = 'X', link: string = '') {
    const snackBarRef = this.service.open(message, closeLabel,  {
      duration: 10000,
      panelClass: 'cim-toastr',
      verticalPosition: 'top',
    });

    if (link) {
      snackBarRef.onAction().subscribe(() => {
        const baseUrl = `${window.location.protocol}//${window.location.host}/#/`;
        const fullUrl = `${baseUrl}${link.startsWith('/') ? link : `/${link}`}`;

        window.open(fullUrl, '_blank');
      });
    }

    return snackBarRef;
  }

  invalidForm() {
    return this.open('Please fill the required fields!');
  }
}
